<template>
  <v-container fluid>
    <v-card class="mb-3" v-show="!loading">
      <v-app-bar color="primary" flat dark dense>
        <v-toolbar-title>Cadastro de Representante</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn text @click="$router.push('/representantes')" :disabled="salvando">Cancelar</v-btn>
          <v-btn text :disabled="!form_valid" :loading="salvando" @click="salvar">Salvar</v-btn>
        </v-toolbar-items>
      </v-app-bar>
      <v-form ref="form" v-model="form_valid" lazy-validation>
        <v-container fluid>
          <h3>Representante</h3>
          <v-layout row wrap>
            <v-flex sm6>
              <v-text-field
                label="Nome Fantasia *"
                ref="nome_fantasia"
                v-model="representante.nome_fantasia"
                @keypress.native.enter="$refs.cnpj.focus()"
                :rules="regras.nome_fantasia"
                autofocus
              ></v-text-field>
            </v-flex>
            <v-flex sm6>
              <v-text-field
                label="CNPJ *"
                ref="cnpj"
                v-model="representante.cnpj"
                @keypress.native.enter="$refs.rua.focus()"
                :rules="regras.cnpj"
                mask="##.###.###/####-##"
                :return-masked-value="true"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex sm4>
              <v-text-field
                label="Rua *"
                ref="rua"
                v-model="representante.endereco.rua"
                @keypress.native.enter="$refs.numero.focus()"
                :rules="regras.rua"
              ></v-text-field>
            </v-flex>
            <v-flex sm2>
              <v-text-field
                label="Número *"
                ref="numero"
                v-model="representante.endereco.numero"
                @keypress.native.enter="$refs.complemento.focus()"
                :rules="regras.numero"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                label="Complemento"
                ref="complemento"
                v-model="representante.endereco.complemento"
                @keypress.native.enter="$refs.bairro.focus()"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                label="Bairro *"
                ref="bairro"
                v-model="representante.endereco.bairro"
                @keypress.native.enter="$refs.estado_id.focus()"
                :rules="regras.bairro"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex sm6>
              <v-autocomplete
                v-model="representante.endereco.estado_id"
                ref="estado_id"
                :items="estados"
                label="Estado *"
                @change="getCidadesLoja"
                @keypress.native.enter="$refs.cidade_id.focus()"
                :rules="regras.estado"
              />
            </v-flex>
            <v-flex sm6>
              <v-autocomplete
                v-model="representante.endereco.cidade_id"
                ref="cidade_id"
                :items="cidades"
                label="Cidade *"
                @keypress.native.enter="$refs.cep.focus()"
                :rules="regras.cidade"
                :loading="load_cidade_representante"
              />
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex sm2>
              <v-text-field
                label="CEP *"
                ref="cep"
                v-model="representante.endereco.cep"
                @keypress.native.enter="$refs.telefone.focus()"
                :rules="regras.cep"
                mask="##.###-###"
                :return-masked-value="true"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                label="Telefone"
                ref="telefone"
                v-model="representante.endereco.telefone"
                @keypress.native.enter="$refs.celular.focus()"
                mask="(##) ####-####"
                :return-masked-value="true"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                label="Celular"
                ref="celular"
                v-model="representante.endereco.celular"
                @keypress.native.enter="$refs.email.focus()"
                mask="(##) #####-####"
                :return-masked-value="true"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                label="Email"
                ref="email"
                v-model="representante.endereco.email"
                :rules="regras.email"
                @keypress.native.enter="$refs.usuario.focus()"
              ></v-text-field>
            </v-flex>
          </v-layout>

          <h3>Usuário</h3>
          <v-layout row wrap>
            <v-flex sm4>
              <v-text-field
                label="Usuário *"
                ref="usuario"
                v-model="representante.user.email"
                :rules="regras.usuario"
                @keypress.native.enter="salvar"
              ></v-text-field>
            </v-flex>
            <v-flex sm4 v-show="!representante.id">
              <v-text-field label="Senha" ref="senha" v-model="senha" @keypress.native.enter="salvar" disabled readonly></v-text-field>
            </v-flex>
          </v-layout>
          <span style="color: darkgray">Os campos com * são obrigatórios</span>
        </v-container>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
import Services from "@/services/services.js";
import ServiceRepresentantes from "@/services/representantes.js";
import validadores from "@/mixins/validadores-mixin";

export default {
  name: "RepresentantesForm",
  mixins: [validadores],
  data() {
    return {
      user: {},
      loading: false,
      salvando: false,
      form_valid: false,
      load_cidade_representante: false,
      representante: {
        nome_fantasia: "",
        cnpj: "",
        endereco: {
          rua: "",
          numero: "",
          complemento: "",
          bairro: "",
          cidade_id: "",
          estado_id: "",
          cep: "",
          telefone: "",
          celular: "",
          email: "",
        },
        user: {
          email: "",
        },
      },
      regras: {
        nome_fantasia: [(value) => !!value || "Campo obrigatório"],
        cnpj: [(value) => !!value || "Campo obrigatório", (value) => this.validarCNPJ(value) || "CNPJ Inválido"],
        rua: [(value) => !!value || "Campo obrigatório"],
        numero: [(value) => !!value || "Campo obrigatório"],
        bairro: [(value) => !!value || "Campo obrigatório"],
        cidade: [(value) => !!value || "Campo obrigatório"],
        estado: [(value) => !!value || "Campo obrigatório"],
        cep: [(value) => !!value || "Campo obrigatório"],
        telefone: [(value) => !!value || "Campo obrigatório"],
        email: [(value) => (value ? this.validarEmail(value) || "Email Inválido" : true)],
        usuario: [(value) => !!value || "Campo obrigatório"],
      },
      estados: Services.estados(),
      cidades: [],
      senha: "123456",
    };
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("user"));

    if (this.$route.params.representante_id) {
      this.editar(this.$route.params.representante_id);
    }
  },
  methods: {
    async salvar() {
      if (this.$refs.form.validate()) {
        try {
          this.salvando = true;

          let response = "";
          if (this.$route.params.representante_id) {
            response = await ServiceRepresentantes.atualizar(this.representante);
          } else {
            response = await ServiceRepresentantes.salvar(this.representante);
          }

          if (response.data.status == 1) {
            this.$eventbus.notificar(response.data.msg);
            this.$router.push("/representantes");
          } else {
            this.$eventbus.erro(response.data.msg);
          }
        } catch (error) {
          console.log(error);
          this.$eventbus.erro("Erro ao salvar representante");
        } finally {
          this.salvando = false;
        }
      }
    },
    async editar(representante_id) {
      try {
        this.loading = true;
        let representante = await ServiceRepresentantes.editar(representante_id);
        this.representante = representante.data.representante;
        this.getCidadesLoja();
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao editar representante");
      } finally {
        this.loading = false;
      }
    },
    async getCidadesLoja() {
      try {
        this.load_cidade_representante = true;
        let response = await Services.cidades(this.representante.endereco.estado_id);
        this.cidades = response.data.cidades;
      } catch (error) {
        console.log(error);
        this.$eventbus.erro("Erro ao buscar cidades");
      } finally {
        this.load_cidade_representante = false;
      }
    },
  },
};
</script>

<style></style>
